import {validateText} from '../mixins/component/validateText';
import {validateNumber} from '../mixins/component/validateNumber';
import {ref, getCurrentInstance, computed} from 'vue';
import {validateCombobox} from '../mixins/component/validateCombobox';
import i18nValidate from '@/i18ns/vi/i18nValidate';
import {useAccountStore} from '@/stores/dictionary/accountStore';
import {useAccountCategoryStore} from '@/stores/dictionary/accountCategoryStore';
export const useValidateControl = ({props}) => {
  const errorMessage = ref('');
  // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
  const isValidate = computed(() => props.rules.length > 0);
  // const isValidate = computed(() => false);
  const {proxy} = getCurrentInstance();

  // danh sách các cột và detail theo tài khoản từng cột
  const MapField = proxy.$ms.constant.MapDetailColumn;

  //Store
  const storeAccount = useAccountStore();
  const storeAccountCategory = useAccountCategoryStore();

  const validate = (inputCol = null) => {
    if (inputCol) {
      props = inputCol;
    }
    // Nếu là editor của grid thì sẽ lấy config từ column
    let rules = [];
    if (proxy._isGridEditor) {
      let dataField = props.col.dataField;

      rules = props.disabledValidate ? [] : props.col.rules;
      if (dataField && MapField[dataField]) {
        const controlValue = getValueControl();
        if (!controlValue) {
          let debitAccount = props.dataRow.debit_account,
            creditAccount = props.dataRow.credit_account,
            isRequired = false;

          if (dataField.startsWith('debit_')) {
            isRequired = CheckRequiredByAccount(dataField, debitAccount);
          } else if (props.col.caption.contains('có') || props.col.caption.contains('Có')) {
            isRequired = CheckRequiredByAccount(dataField, creditAccount);
          } else {
            isRequired =
              CheckRequiredByAccount(dataField, creditAccount) || CheckRequiredByAccount(dataField, debitAccount);
          }

          if (isRequired) {
            rules = [
              {
                name: 'required',
              },
            ];
          }
        }
      }
    } else {
      rules = props.rules;
    }
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const {name, compareValue, customValidate} = rule;
          const controlValue = props.col?.colIndex == -1 ? null : getValueControl();
          // Nếu có custom validate sẽ lấy theo customvalidate
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(controlValue, compareValue, getTitleError(), props.dataRow, props);
            if (message) {
              break;
            }
          } else {
            message = handlerRule(name, controlValue, compareValue);
            if (message) {
              break;
            }
          }
        }
      }
    }

    //  ntduong2 20/8/2024 Thi công validate tài khoản hạch toán
    if (proxy._isGridEditor) {
      let dataField = props.col.dataField;
      // Thi công check validate với tài khoản nợ có cho câu thông báo khác
      if (dataField == 'debit_account' || dataField == 'credit_account') {
        // nếu là TK nợ/có là tài khoản bắt đầu bằng số 0
        if (dataField == 'debit_account') {
          //Thay đổi thành null mà ô còn lại cũng null
          if (!props.dataRow.debit_account && !props.dataRow.credit_account) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          }
          if (
            !props.dataRow.debit_account &&
            props.dataRow.credit_account &&
            !props.dataRow.credit_account?.startsWith('0')
          ) {
            //Thay đổi thành null mà tài khoản có đang tồn tại và ko bắt đầu = 0
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          } else if (props.dataRow.credit_account?.startsWith('0')) {
            message = '';
          }
        } else {
          //Thay đổi thành null mà ô còn lại cũng null
          if (!props.dataRow.debit_account && !props.dataRow.credit_account) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          }
          //Thay đổi thành null mà tài khoản nợ đang tồn tại và ko bắt đầu = 0
          if (
            !props.dataRow.credit_account &&
            props.dataRow.debit_account &&
            !props.dataRow.debit_account?.startsWith('0')
          ) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          } else if (props.dataRow.debit_account?.startsWith('0')) {
            message = '';
          }
        }
      }
    }

    errorMessage.value = message;
    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };

  /**
   * Validate trường thông tin chi tiết theo
   * ntduong2 20.8.2024
   * @param {*} dataField
   * @param {*} accountNumber
   * @returns
   */
  const CheckRequiredByAccount = (dataField, accountNumber) => {
    if (!accountNumber) {
      return false;
    }
    let accountDetail = storeAccount.items.find(x => x.account_number == accountNumber);
    if (accountDetail) {
      let accountCategoryDetail = storeAccountCategory.items.find(
        x => x.account_category_code == accountDetail.account_category_code,
      );
      if (accountCategoryDetail && MapField[dataField].includes(accountCategoryDetail.is_detail_by)) {
        return true;
      }
    }
    return false;
  };

  /**
   * Xử lý các rule validate
   * @param {*} rule tên rule
   * @param {*} compareValue value
   * @returns
   */
  const handlerRule = (rule, controlValue, compareValue) => {
    let message = '';

    const titleError = getTitleError();
    switch (rule) {
      case 'required':
        if (controlValue === undefined || controlValue === null || controlValue === NaN || controlValue === '') {
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor);
        }
        break;
      case 'moreThan':
        break;
      case 'lessThan':
        break;
      case 'lessThanAmount':
        if (
          controlValue !== undefined &&
          controlValue !== null &&
          !isNaN(controlValue) &&
          compareValue !== undefined &&
          compareValue !== null &&
          !isNaN(compareValue)
        ) {
          if (parseInt(controlValue) > 0) {
            if (parseInt(controlValue) >= parseInt(compareValue)) {
              message = i18nValidate.messages[rule](titleError);
            }
          } else {
            if (parseInt(controlValue) <= parseInt(compareValue) * -1) {
              message = i18nValidate.messages[rule](titleError);
            }
          }
        }
        break;
      case 'equals':
        break;
      case 'pattern':
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages['email'](titleError);
        }
        break;
      case 'diffierentZero':
        if (!validateNumber.validatediffierentZero(controlValue)) {
          message = i18nValidate.messages['diffierentZero'](titleError);
        }
        break;
      default:
        break;
    }
    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };

  /**
   * Xử lý validate riêng cho combobox
   */
  const handlerValidateCombobox = () => {
    const {rules} = props;
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const {name, compareValue, customValidate} = rule;
          // Nếu có custom validate sẽ lấy theo customvalidate
          const controlValue = getValueControl();
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(controlValue, compareValue, getTitleError(), props.dataRow, props);
          } else {
            message = validateCombobox.validateRule(name, proxy);
          }
          if (message) {
            break;
          }
        }
      }
    }

    errorMessage.value = message;

    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };

  const clearValidate = () => {
    errorMessage.value = '';
  };
  /**
   * Lấy value của control (Các control override hàm này)
   * @returns
   */
  const getValueControl = () => {
    return proxy.getValue();
  };

  /**
   * Lấy title của error
   * @returns
   */
  const getTitleError = () => {
    const {title} = props;
    if (proxy._isGridEditor) {
      return props.col.caption;
    }
    return title || getValidateName();
  };

  /**
   * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
   */
  const getValidateName = () => {
    const fn = function (el, c) {
      if (!el || c > 10) {
        return null;
      }

      const labelEl = el.querySelector('label');
      if (labelEl) {
        return (labelEl.innerText || '').replace('*', '');
      }

      return fn(el.parentNode, c + 1);
    };

    return fn(proxy.$el, 0);
  };
  return {
    errorMessage,
    validate,
    handlerValidateCombobox,
    getTitleError,
    clearValidate,
    isValidate,
  };
};
